import axios from 'axios';
import { REACT_APP_API_URL } from '../../config';
import { logout } from '../../screens/Login/actions';

const APIClient = axios.create({
  baseURL: REACT_APP_API_URL,
});

export const configureAPIClient = (store) => {
  APIClient.interceptors.response.use((response) => response, (error) => {
    const state = store.getState();
    const logoutStatuses = [502, 401];

    if (error.response) {
      const isLogoutRequest = error.response.request.responseURL.includes('logout');
      const isLogoutRequired = logoutStatuses.includes(error.response.status)
        && !state.login.tokenRefreshing
        && !state.login.isFetching
        && !isLogoutRequest;

      if (isLogoutRequired) {
        store.dispatch(logout());
      }
    }

    return Promise.reject(error);
  });

  APIClient.interceptors.request.use((config) => {
    const state = store.getState();
    const { token } = state.login;

    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  });
};

export default APIClient;
